export const GA_PROPERTY_ID_MAC_DESKTOP = 'GA_PROPERTY_ID_MAC_DESKTOP';
export const GA_PROPERTY_ID_WINDOWS_DESKTOP = 'GA_PROPERTY_ID_WINDOWS_DESKTOP';
export const GA_PROPERTY_ID = 'GA_PROPERTY_ID';
